import React from "react";
import axios from "axios";
import "../../App.css";

function DeleteSnapVariant({ selectedVariant, setSelectedVariant, setData }) {
  if (!selectedVariant) return null;

  const fetchVariants = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}api/data/snapVariants`);
      setData(res.data);
    } catch (err) {
      console.error("Failed to refresh variants:", err);
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}api/deleteSnapVariant/${selectedVariant.id}`
      );
      fetchVariants();
      setSelectedVariant(null);
    } catch (error) {
      console.error("Error deleting snap variant:", error);
    }
  };

  return (
    <div className="styled-info-modal">
      <h2 className="modal-title" style={{ color: "rgb(197,176,55)" }}>
        Delete Variant
      </h2>

      <p style={{ color: "#ddd", textAlign: "center", marginBottom: "16px" }}>
        Did you get this variant?
      </p>

      <div style={{ display: "flex", justifyContent: "center", marginBottom: "16px" }}>
        <img
          src={selectedVariant.cardhtml}
          alt={selectedVariant.cardname || "Variant"}
          style={{
            maxWidth: "260px",
            borderRadius: "8px",
            boxShadow: "0 0 12px rgba(255,255,255,0.2)",
          }}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
        <button
          className="button"
          onClick={handleDelete}
          style={{ background: "#a33" }}
        >
          Firehair Yeah I Did!
        </button>
        <button
          className="button"
          onClick={handleDelete}
          style={{ background: "#a33" }}
        >
          I don't want it anymore
        </button>
        <button className="button" onClick={() => setSelectedVariant(null)}>
          Maybe I keep it
        </button>
      </div>
    </div>
  );
}

export default DeleteSnapVariant;
